import gql from 'graphql-tag';

export const unreadCountersSubscription = gql`
  subscription unreadCounters {
    unreadCounters {
      ... on InitialUnreadCount {
        notifications
        messages
      }
      ... on NewUnread {
        emission
      }
    }
  }
`;
